import React from 'react';
import ProductCard from './ProductCard';
import W1 from "../../Images/W1.webp";
import W2 from "../../Images/W2.webp";
import W3 from "../../Images/W3.webp";
import W4 from "../../Images/W4.jpg";
import W5 from "../../Images/W5.webp";
import W6 from "../../Images/W6.webp";
import W7 from "../../Images/W7.jpg";
import W8 from "../../Images/W8.webp";
import W9 from "../../Images/W9.jpg";
import W10 from "../../Images/W10.jpg";
import W11 from "../../Images/W11.webp";
import W12 from "../../Images/W12.avif";
import W13 from "../../Images/W13.avif";
import W14 from "../../Images/W14.jpg";
import W15 from "../../Images/W15.webp";
import W16 from "../../Images/W16.jpg";
import W17 from "../../Images/W17.webp";
import W18 from "../../Images/W18.jpg";
import W19 from "../../Images/W19.webp";
import W20 from "../../Images/W20.jpeg";

const womenProducts = [
  // Lehengas
  { id: 1, image: W1, name: "Bridal Red Lehenga", price: 15999 },
  { id: 2, image: W2, name: "Embroidered Silk Lehenga", price: 13999 },
  { id: 3, image: W3, name: "Designer Zari Lehenga", price: 17999 },
  { id: 4, image: W4, name: "Pastel Pink Lehenga", price: 12999 },
  { id: 5, image: W5, name: "Velvet Heavy Work Lehenga", price: 19999 },
  { id: 6, image: W6, name: "Mirror Work Lehenga", price: 14999 },
  { id: 7, image: W7, name: "Golden Bridal Lehenga", price: 18999 },
  { id: 8, image: W8, name: "Handwoven Banarasi Lehenga", price: 16999 },
  { id: 9, image: W9, name: "Royal Blue Velvet Lehenga", price: 18999 },
  { id: 10, image: W10, name: "Classic White Pearl Lehenga", price: 15999 },

  // Gowns
  { id: 11, image: W11, name: "Red Evening Gown", price: 12999 },
  { id: 12, image: W12, name: "Sequined Mermaid Gown", price: 13999 },
  { id: 13, image: W13, name: "Floral Embroidered Gown", price: 11999 },
  { id: 14, image: W14, name: "Ballroom Princess Gown", price: 14999 },
  { id: 15, image: W15, name: "Satin Off-Shoulder Gown", price: 9999 },
  { id: 16, image: W16, name: "Crystal Beaded Gown", price: 15999 },
  { id: 17, image: W17, name: "Lace Trail Wedding Gown", price: 17999 },
  { id: 18, image: W18, name: "Royal Blue A-Line Gown", price: 14999 },
  { id: 19, image: W19, name: "Velvet Embellished Gown", price: 18999 },
  { id: 20, image: W20, name: "Elegant Black Evening Gown", price: 13999 },
];

function Wclothes() {
  return (
    <div className="product-container">
      {womenProducts.map((item) => (
        <ProductCard key={item.id} image={item.image} name={item.name} price={item.price} />
      ))}
    </div>
  );
}

export default Wclothes;
